import { createSignal } from "solid-js";
import { Icon } from "~/ui/Icon";

export function DeleteClassModal(props: { value: { name: string }; onClose: () => void; onConfirm: () => Promise<void> }) {
  const [confirmation, setConfirmation] = createSignal("");
  const [busy, setBusy] = createSignal(false);
  const [error, setError] = createSignal("");
  const matches = () => confirmation().trim() === props.value.name;

  const remove = async () => {
    if (!matches()) return;
    setBusy(true);
    setError("");
    try { await props.onConfirm(); }
    catch (cause) { setError(cause instanceof Error ? cause.message : "Fehler beim Löschen"); }
    finally { setBusy(false); }
  };

  return (
    <div class="modal-overlay active" style={{ "z-index": 9000 }} onClick={(event) => event.target === event.currentTarget && props.onClose()}>
      <div style={{ background: "#fff", "border-radius": "16px", padding: "32px", "max-width": "420px", width: "100%", "box-shadow": "0 20px 60px rgba(0,0,0,0.3)" }} role="dialog" aria-modal="true" aria-label="Klasse löschen?">
        <div style={{ "text-align": "center", "margin-bottom": "24px" }}>
          <div style={{ "font-size": "3.5rem", "margin-bottom": "12px" }}><Icon name="trash" style={{ width: "56px", height: "56px" }} /></div>
          <h2 style={{ "margin-bottom": "8px" }}>Klasse löschen?</h2>
          <p style={{ color: "var(--text-muted)" }}>Du bist dabei, die Klasse <strong>{props.value.name}</strong> zu löschen.</p>
          <p style={{ "margin-top": "12px", "font-size": "0.85rem", color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca", "border-radius": "8px", padding: "10px 14px" }}>
            <Icon name="warning" style={{ width: "16px", height: "16px" }} /> Alle Check-in Daten, Ziele und Abstimmungen dieser Klasse werden dauerhaft deaktiviert.
          </p>
        </div>
        <p style={{ "font-size": "0.9rem", "margin-bottom": "8px", "font-weight": 600 }}>Zur Bestätigung bitte den Klassennamen eingeben:</p>
        <input class="form-input" value={confirmation()} onInput={(event) => setConfirmation(event.currentTarget.value)} placeholder={props.value.name} autocomplete="off" style={{ "margin-bottom": "20px", "text-align": "center", "font-weight": 700, "letter-spacing": "1px" }} />
        {error() && <div class="form-error" style={{ "margin-bottom": "12px" }} role="alert">{error()}</div>}
        <div style={{ display: "flex", gap: "12px" }}>
          <button class="btn btn-secondary btn-full" type="button" onClick={props.onClose}>Abbrechen</button>
          <button class="btn btn-full" type="button" disabled={!matches() || busy()} onClick={remove} style={{ background: "#dc2626", color: "#fff", opacity: matches() ? 1 : 0.4, cursor: matches() ? "pointer" : "not-allowed" }}>Endgültig löschen</button>
        </div>
      </div>
    </div>
  );
}
